/** 値がnull または undefined でないかどうかを判定する
 *
 * filterと組み合わせることで nullとundefinedを含まない配列を型レベルを得られる
 * */
export const isNotNullish = <T>(value: T | undefined | null): value is T => {
  return value != null && value !== undefined
}
